import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PageHeadline from "../../components/shared/PageHeadline";
import API_URL from "../../config/constant";
export default function CategoryPodium() {
    const { t } = useTranslation();

    const [data, setData] = useState(null);
    const locale = useSelector((state) => state.locale.locale);
    useEffect(() => {
        const fetchAboutData = async () => {
            try {
                const response = await fetch(`${API_URL}/faq?lang=${locale}`);
                if (!response.ok) {
                    throw new Error("Data not found");
                }
                const res = await response.json();
                if (res.podium.data.length < 1) {
                    throw new Error("Data not found");
                }
                setData(res.podium);
            } catch (error) {
                setData(t("home.podium", { returnObjects: true }));
            }
        };

        fetchAboutData();
    }, [t, locale]);
    return (
        <>
            <div className="text-white md:px-0 px-4 bg-white xl:pb-96 lg:pb-80 pb-40">
                <div className="relative min-h-[240px] lg:min-h-[300px] bg-bgBannerPage bg-contain md:bg-cover bg-no-repeat top-[86px] md:top-[109px] 2xl:top-[136px] flex justify-center items-center">
                    <PageHeadline title={data?.title} />
                </div>
                <div className="top-12 md:top-20 lg:top-40 xl:top-60 relative flex w-full items-center justify-center mt-10 text-center font-poppins">
                    <div className="grid md:grid-cols-3 gap-10 w-5/6 xl:w-4/6">
                        {data?.data.map((value, index) => (
                            <div className="border border-[#164481] rounded-lg" key={index}>
                                <div className="2xl:py-8 py-7 bg-[#edcd38] backdrop-blur-xl text-center rounded-t-lg">
                                    <h1 className="font-bold md:text-3xl text-xl text-[#164481]">
                                        {value.title}
                                    </h1>
                                </div>
                                <div className="bg-[#164481] py-5 px-5 rounded-b-lg font-normal font-poppins h-36 2xl:text-base text-sm flex items-center">
                                    <p dangerouslySetInnerHTML={{ __html: value.desc }} />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
}
